export enum Device {
  UNSPECIFIED = 0,
  DESKTOP_WEB = 1,
  MOBILE_WEB = 2,
  ANDROID_APP = 3,
  IOS_APP = 4,
}

// The current countries which are available to shop in
export enum Country {
  UNSPECIFIED = 0,
  GERMANY = 1,
  SWITZERLAND = 2,
  AUSTRIA = 3,
  NETHERLANDS = 4,
  BELGIUM = 5,
  POLAND = 6,
  CZECHIA = 7,
  SLOVAKIA = 8,
  ROMANIA = 9,
  HUNGARY = 10,
  SLOVENIA = 11,
  LATVIA = 12,
  LITHUANIA = 13,
  ESTONIA = 14,
  CROATIA = 15,
  BULGARIA = 16,
  DENMARK = 17,
  IRELAND = 18,
  FRANCE = 19,
  SWEDEN = 20,
  FINLAND = 21,
  SPAIN = 22,
  ITALY = 23,
  PORTUGAL = 24,
  NORWAY = 25,
  GREECE = 26,
  GLOBAL = 27,
  SAUDI_ARABIA = 28,
  ISRAEL = 29,
  CYPRUS = 30,
  LUXEMBOURG = 31,
}

// The current languages which are supported in the AY shop
export enum Language {
  UNSPECIFIED = 0,
  GERMAN = 1,
  FRENCH = 2,
  DUTCH = 3,
  POLISH = 4,
  CZECH = 5,
  SLOVAK = 6,
  ROMANIAN = 7,
  HUNGARIAN = 8,
  SLOVENIAN = 9,
  LATVIAN = 10,
  LITHUANIAN = 11,
  ESTONIAN = 12,
  CROATIAN = 13,
  BULGARIAN = 14,
  DANISH = 15,
  ENGLISH = 16,
  SWEDISH = 17,
  FINNISH = 18,
  SPANISH = 19,
  ITALIAN = 20,
  PORTUGUESE = 21,
  NORWEGIAN = 22,
  GREEK = 23,
  MODERN_STANDARD_ARABIC = 28,
  MODERN_HEBREW = 29,
  RUSSIAN = 30,
}

// An active AB test for the client.
export interface ABTest {
  // The unique identifier (key) for the AB test.
  key: string;
  // The AB test the user/client is currently in.
  //
  // As a convention we name the control group `control`
  // and the actual ab test variants are named `variant1`, `variant2` etc.
  group: string;
}

// A common shared type between all requests
//
// It specificies some general data needed for all requests, but also meta data about the client which made the request.
// That allows us to add this meta data to new relic requests, or even see how many requests are done by which version.
export interface Config {
  // The country and the chosen language of the user.
  //
  // Currently these fields are not freely choosable, e.g. in Germany you can only choose the German language.
  // This however can change in the future without needing to adjust this interface.
  country: Country;
  language: Language;
  // The device type of the client.
  //
  // This is required and can be used for adjusting the business logic on the server.
  device: Device;
  // An optional client version.
  //
  // It is encouraged to provide this value, to allow better debugging and error reporting on the server.
  //
  // The format should be in a normalized way, for the App we will send the version and build number, e.g. `6.7.2+4106023`.
  // For the web stacks, it will be enough to just send the release version of the client, e.g. `1.5.2`.
  clientVersion: string;
  // A unique trace id which will be appended to all requests which are triggered by the this one.
  //
  // This allows to exactly see which other requests are being made for a given request from the client.
  traceId?: string;
  // A list of active AB tests for the client
  //
  // This should be send on all endpoints even if the AB tests aren't used on an endpoint right now.
  abTests: ABTest[];
  // A unique device ID provided by Adjust.
  // It will be provided by the app once tracking consent is given by the user
  adjustId?: string;
  // A vendor-specific privacy-friendly device-unique identifier, also called IDfV (iOS) or App Set ID (Android).
  vendorId?: string;
}
